import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {GtmService} from "../../service/gtm/gtm.service";
import {BoardService} from "app/service/board/board.service";

@Component({
  selector: 'app-mypage',
  templateUrl: './mypage.component.html',
  styleUrls: ['./mypage.component.scss'],
  providers: [BoardService]
})
export class MypageComponent implements OnInit {

  pageCategory: string;
  categoryTitle = {
    'community' : 'Hey!',
    'event': 'Event',
    'free': 'Board'
  };

  constructor(private boardService: BoardService,
              private route: ActivatedRoute,
              private router: Router,
              private gtmService: GtmService) {

    this.getKeyword();
    this.getCate();

    this.route.params.subscribe(
      params => {
       this.pageCategory = params['category'];

        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': this.categoryTitle[this.pageCategory],
          'breadcrumb': 'Home > Member > My Page'
        });
      }
    );

    this.route.queryParams.subscribe(
      params => {
        this.location = params['location']  ? params['location']            : '';
        this.category = params['category']  ? params['category'].split(',') : [];
        this.h_tag    = params['h_tag']     ? params['h_tag']               : '';
        this.c_tag    = params['c_tag']     ? params['c_tag']               : '';
        this.active   = params['active']    ? params['active']              : '';
      }
    );
  }

  ngOnInit() {
  }

  reload() {
    let url = this.router.url.split('?')[0];

    this.router.navigateByUrl(
      `${url}?page=1` +
      `${this.location ? `&location=${this.location}`: ''}` +
      `${this.active ? `&active=${this.active}`: ''}` +
      `${this.selectedCate.length ? `&category=${this.selectedCate}`: ''}` +
      `${this.h_tag ? `&h_tag=${this.h_tag}`: ''}` +
      `${this.c_tag ? `&h_tag=${this.c_tag}`: ''}`);
  }

  location: string;
  onLocation(location: string) {
    this.location = location
    this.reload();
  }

  category: string[];
  categories: any[];
  getCate() {
    this.boardService.getCategory().subscribe(
      ({categories}) => {
        this.categories = categories.map(o => ({
          value: o,
          checked: this.category.findIndex(opt => opt == o) != -1
        }))
      }
    )
  }
  onCate() {
    this.category = this.selectedCate;
    this.reload();
  }
  get selectedCate() {
    return this.categories.filter(opt => opt.checked).map(opt => opt.value);
  }

  hey_keywords: string[];
  com_keywords: string[];
  getKeyword() {
    this.boardService.getHeyKeyword().subscribe(
      ({keywords}) => this.hey_keywords = keywords
    )
    this.boardService.getCommunityKeyword().subscribe(
      ({keywords}) => this.com_keywords = keywords
    )
  }

  h_tag: string;
  onHeyTag(tag: string) {
    if(this.h_tag === tag) {
      this.h_tag = ''
    } else {
      this.h_tag = tag
    }
    this.reload();
  }
  c_tag: string;
  onComTag(tag: string) {
    if(this.c_tag === tag) {
      this.c_tag = ''
    } else {
      this.c_tag = tag
    }
    this.reload();
  }

  active: string;
  onActive(active: string) {
    if(active === 'all') {
      this.active = ''
    } else {
      this.active = active;
    }
    this.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/member/mypage/mypage.component.ts